<template>
  <div>
    <v-row no-gutters class="">
      <span class="textLight--text font-weight-medium text-h5 text-left">
        {{
          isPublicProfile
            ? $t("user.profile.achievements")
            : $t("user.profile.myAchievements")
        }}
      </span>
    </v-row>

    <v-row v-if="loading">
      <v-col>
        <achievement-loader :vertical="vertical" />
      </v-col>
    </v-row>

    <v-row v-else-if="achievements && achievements.length">
      <v-col
        v-for="(achievement, index) in achievements"
        :key="index"
        cols="12"
        sm="6"
        :md="vertical ? '12' : '6'"
        :lg="vertical ? '12' : '4'"
        :xl="vertical ? '12' : '3'"
        :class="vertical ? 'mb-md-4' : ''"
      >
        <achievement-card
          :data="achievement"
          :subscriberInfo="subscriberInfo"
        />
      </v-col>
    </v-row>

    <v-row v-else justify="center" align="center">
      <v-col cols="10" sm="8" md="10">
        <empty-courses
          :heading="$t('user.profile.noAchievements')"
          :isOnSide="$vuetify.breakpoint.mdAndUp"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import AchievementCard from "../AchievementCard.vue";
import EmptyCourses from "../../../course-module/components/EmptyCourses";
import AchievementLoader from "../skeleton-loaders/AchievementLoader";

export default {
  components: {
    AchievementLoader,
    AchievementCard,
    EmptyCourses,
  },
  props: {
    vertical: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: true,
      userProfile: null,
      achievements: [],
      subscriberInfo: null,
    };
  },
  computed: {
    isPublicProfile() {
      return this.$route.name === "PublicProfile";
    },
    getProfileVariables() {
      return {
        id: this.isPublicProfile ? this.$route.params.id : undefined,
      };
    },
  },
  apollo: {
    getProfile() {
      return {
        query: require("../../api/query/getProfile.gql"),
        variables: this.getProfileVariables,
        result({ data, loading }) {
          if (data && data.getProfile) {
            this.userProfile = data.getProfile;
            const roleKey = this.userProfile?.role?.toLowerCase();
            this.achievements = this.userProfile[
              roleKey
            ]?.trainingCertificates?.map(x => {
              if (!x.employee?.user) {
                x.employee = {
                  ...x.employee,
                  user: this.userProfile,
                };
              }

              return x;
            });
          }

          this.loading = loading;
        },
      };
    },
    getSubscriberProfile() {
      return {
        query: require("../../api/query/getSubscriberProfile.gql"),
        result({ data }) {
          if (data?.getSubscriberProfile) {
            this.subscriberInfo = data.getSubscriberProfile;
          }
        },
      };
    },
  },
  watch: {
    isPublicProfile() {
      this.refetchGetProfile();
    },
  },
  methods: {
    refetchGetProfile() {
      this.loading = true;
      this.userProfile = null;
      this.achievements = [];
      this.$apollo.queries.getProfile.refetch(this.getProfileVariables);
    },
  },
};
</script>
